import { CombinedError } from '@urql/core';
import { showErrorMessage } from 'components/Helpers/Toasts';
import { getUserFriendlyErrors } from 'connectors/lib/friendlyErrorMessageParser';
import { ApplicationErrors } from 'helpers/errors/applicationErrors';
import { Translate } from 'next-translate';
import { FieldValues, Path, UseFormReturn } from 'react-hook-form';
import { GtmMessageOriginType } from 'types/gtm';

export const handleFormErrors = <T extends FieldValues>(
    error: CombinedError | undefined,
    formProviderMethods: UseFormReturn<T>,
    t: Translate,
    errorMessage: string | undefined = undefined,
    fields: Record<string, { name: string }> | undefined = undefined,
    origin: GtmMessageOriginType = GtmMessageOriginType.other,
): void => {
    if (error === undefined) {
        return;
    }

    const { userError, applicationError } = getUserFriendlyErrors(error, t);

    if (applicationError !== undefined) {
        showErrorMessage(
            errorMessage !== undefined && applicationError.type === ApplicationErrors.default
                ? errorMessage
                : applicationError.message,
            origin,
        );
    }

    if (userError?.validation !== undefined) {
        for (const fieldName in userError.validation) {
            if (fields !== undefined && Object.keys(fields).some((fieldKey) => fields[fieldKey].name === fieldName)) {
                formProviderMethods.setError(fieldName as Path<T>, userError.validation[fieldName]);
                continue;
            }

            const validationCode = userError.validation[fieldName].code;
            const validationMessage = userError.validation[fieldName].message;
            showErrorMessage(validationCode?.startsWith('AIRME_') ? t(validationMessage) : validationMessage, origin);
        }
    }
};
